import { render, staticRenderFns } from "./Usercenter.vue?vue&type=template&id=d0660afa&scoped=true"
import script from "./Usercenter.vue?vue&type=script&lang=js"
export * from "./Usercenter.vue?vue&type=script&lang=js"
import style0 from "./Usercenter.vue?vue&type=style&index=0&id=d0660afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0660afa",
  null
  
)

export default component.exports